import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
export { SummaryStat } from '../../reusableUI/summary/SummaryStat';

export const SummaryPanel = ({ id, title, question, icon: Icon, href, section, children, className = '' }) => {
    if (section?.status === 'restricted') return null;
    return <section className={`home-week-panel ${className}`} id={id} aria-labelledby={`${id}-title`}>
        <div className="home-week-panel-heading">
            <h2 id={`${id}-title`}>{Icon && <Icon size={19} aria-hidden="true" />}{title}</h2>
            {href && <Link to={href} className="home-week-link">Ver módulo <ArrowUpRight size={15} aria-hidden="true" /></Link>}
        </div>
        <p className="home-week-question">{question}</p>
        {section?.status === 'error'
            ? <p className="home-week-empty" role="status">No pudimos consultar este módulo. Usa Actualizar para reintentar.</p>
            : children}
    </section>;
};
